import React from "react"
import { Link as PrismicLink } from "prismic-reactjs"

import { CenteredWysiwygType } from "types/shared-components"
import Button from "legacy/components/shared/Button"
import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import RichText from "legacy/components/shared/RichText"
import { useTheme } from "src/legacy/utils"

interface OwnProps {
  data: Maybe<CenteredWysiwygType>
}

export type CenteredWysiwygProps = OwnProps

const CenteredWysiwyg: React.FC<CenteredWysiwygProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data?.primary) return null

  const buttonText = data.primary.button_text
  const buttonUrl = data.primary.button_url
  const linkType = data.primary.button_url?.link_type
  const richText = data.primary.wysiwyg
  const showButton = buttonText && buttonUrl
  const { sizes } = useTheme()

  return (
    <Grid gridTemplateColumns="repeat(12, 1fr)" maxWidth={sizes.maxWidth}>
      <Element
        gridColumnEnd={[13, 13, 11]}
        gridColumnStart={["span 12", "span 12", 3]}
        px={["20", "40"]}
        textAlign={["left", "center"]}
      >
        <RichText
          mb={showButton ? "0" : ["50", "110"]}
          render={richText?.richText}
        />
        {showButton && (
          <Link
            display="block"
            mb={["50", "110"]}
            mt={["40", "70"]}
            to={
              linkType === "Document"
                ? PrismicLink.url(buttonUrl)
                : (buttonUrl?.url as string)
            }
          >
            <Button fontSize={["16", "16"]}>{buttonText}</Button>
          </Link>
        )}
      </Element>
    </Grid>
  )
}

export default CenteredWysiwyg
